var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "block-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "column-layout flex" }, [
        _c("div", { staticClass: "form-info" }, [
          _c("div", { staticClass: "form-row col col-6 fl" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.no))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row col col-6 fl" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.stateText))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row col col-6 fl" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row col col-6 fl" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row col col-6 fl" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.servcTitle))])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block-container" },
        [
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("服务商信息")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "swb-btn-link",
                on: {
                  click: function($event) {
                    _vm.selectServicer()
                  }
                }
              },
              [_vm._v("选择")]
            ),
            _vm._v(" "),
            _vm.viewAsginThis
              ? _c(
                  "a",
                  {
                    staticClass: "swb-btn-link",
                    on: {
                      click: function($event) {
                        _vm.assignSelf()
                      }
                    }
                  },
                  [_vm._v("指给自己")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.authServicerList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "servicerName", label: "名称" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dateStart", label: "开始时间" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dateEnd", label: "截止时间" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("网点信息")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "swb-btn-link",
                on: {
                  click: function($event) {
                    _vm.selectServicerShop()
                  }
                }
              },
              [_vm._v("选择")]
            )
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.servicerComList, border: "" }
            },
            [
              _c("el-table-column", { attrs: { prop: "name", label: "名称" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "地址" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "contactName", label: "联系人" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "contactTel", label: "联系电话" }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("工单基本信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("状态：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("客户名称：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("客户机构：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f1badf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1badf4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/rentServc/ServcWorkVoucherDispatch.vue
// module id = 2004
// module chunks = 1